// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fg-3";
export var downloadButton = "_fg-4";
export var fileContainer = "_fg-9 _fg-7";
export var fileContainerBase = "_fg-7";
export var fileContainerFixedHeight = "_fg-8 _fg-7";
export var fileInfo = "_fg-5";
export var fileInfoWidthRestricted = "_fg-6";
export var fileType = "_fg-1";
export var fileTypeName = "_fg-2";
export var image = "_fg-0";
export var link = "_fg-b";
export var overflowEllipsis = "_fg-a";